import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../utility/getTemplateData';
import { Button, V2PaypalIcon } from '@paypalcorp/pp-react';
import { isExternalFlow } from '../utility/productIntegrationUtils';
const messages = localsMessages('common/nextButton');

class NextButtonComponent extends React.Component {
  render() {
    const buttonnext = messages.button && messages.button.next;

    return (
      <>
        {isExternalFlow() ? (
          <Button
            className="btn-wide next-button"
            id="payWithPP"
            disabled={this.props.disabled}
            onClick={this.props.handleNext}
          >
            {buttonnext}
          </Button>
        ) : (
          <Button
            branded
            className="btn-wide next-button"
            id="payWithPP"
            disabled={this.props.disabled}
            onClick={this.props.handleNext}
            iconComponent={V2PaypalIcon}
          >
            {buttonnext}
          </Button>
        )}
      </>
    );
  }
}

NextButtonComponent.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  handleNext: PropTypes.func,
};

export default NextButtonComponent;
